import { apiGet } from "../ApiMethod";
import { CheckValue } from "../../service";
import { setAppReleaseData } from "../../mappers";

export const appReleaseList = async (data = {}, config = {}) => {
  const response = await apiGet("_appRelease", data, null, config);

  const releases = CheckValue(response?.data?.releases)
    ? response.data?.releases
    : [];
    console.log("response",{response,releases})
  return {
    ...response,
    rowData: releases.map(setAppReleaseData),
  };
};
